import CardFixed from "components/Card/CardFixed";
import { getDefaultValue, getPermission } from "components/CommonLib/CommonLib";
import ComboBox from "components/LabelInput/ComboBox";
import SearchComboBox from "components/LabelInput/SearchComboBox";
import NormalBtn from "components/NewButton/NormalBtn";
import _ from "lodash";
import { hq_branch_search_init_state } from "pages/CommonModal/Search/Module/reducers/hq_branch_search_init_state";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MemberConditionArea from "./SearchCondition/MemberConditionArea";
import SearchDetailArea from "./SearchCondition/SearchDetailArea";

const SearchCard = ({
  baseSearchParam,
  setBaseSearchParam,
  detailSearchParam,
  setDetailSearchParam,
  resetSearchParam,
  onClickSearch,
  detailOption,
  setDetailOption,
  openModal,
  onChangeDetailOption,
}) => {
  const storesDispatch = useDispatch();

  const [openMemberInfo, setOpenMemberInfo] = useState(false);
  const [openSearchDetail, setOpenSearchDetail] = useState(false);
  const [hqIdx, setHqIdx] = useState(0);
  const [hqBranchData, setHqBranchData] = useState(_.cloneDeep(hq_branch_search_init_state));
  const [resetFlag, setResetFlag] = useState(false);

  // const hqBranchData = useSelector((state) => state.search_modal.search_param_member);

  useEffect(() => {
    getPermission(storesDispatch, "SEARCH_MEMBER_MENU/SEARCH_MANAGE", true).then((res) => {
      setHqBranchData(res);
      setBaseSearchParam((prev) => {
        return {
          ...prev,
          hq_info: res.target_list[0].hq_info,
          branch_info: res.target_list[0].branch_list[0],
        };
      });
      setHqIdx(0);
    });
  }, []);

  const onSelectHq = (hqName) => {
    const index = hqBranchData.hq_list.findIndex((el) => el === hqName);
    if (index !== -1) {
      setHqIdx(index);
      // baseSearchParam.hq_info = hqBranchData.target_list[index].hq_info;
      setBaseSearchParam((prev) => {
        return {
          ...prev,
          hq_info: hqBranchData.target_list[index].hq_info,
          branch_info: hqBranchData.target_list[index].branch_list[0],
        };
      });
      // baseSearchParam.branch_info = hqBranchData.target_list[index].branch_list[0];
    }
  };

  const onSelectBranch = (branchName) => {
    const index = hqBranchData.branch_list[hqIdx].findIndex((el) => el === branchName);
    if (index !== -1) {
      setBaseSearchParam((prev) => {
        return {
          ...prev,
          branch_info: hqBranchData.target_list[hqIdx].branch_list[index],
        };
      });
      // baseSearchParam.branch_info = hqBranchData.target_list[hqIdx].branch_list[index];
    }
  };

  // reset 후 기본 조건 설정
  useEffect(() => {
    if (!baseSearchParam.branch_info.branch_name) {
      setBaseSearchParam((prev) => ({
        ...prev,
        hq_info: hqBranchData.target_list[0].hq_info,
        branch_info: hqBranchData.target_list[0].branch_list[0],
      }));
    }
  }, [baseSearchParam]);

  return (
    <>
      <CardFixed
        topDom={<div>검색 조건</div>}
        midDom={
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                marginTop: "1rem",
                gap: "0.25rem",
              }}
            >
              <NormalBtn
                name="조건 불러오기"
                theme="white"
                width="10.5rem"
                onClick={() => {
                  openModal("load", {
                    title: "검색조건 불러오기",
                    branch_id: baseSearchParam.branch_info.branch_id,
                  });
                }}
              />

              <NormalBtn
                name="조건 저장"
                width="10.5rem"
                onClick={() => {
                  openModal("save", {
                    title: "검색조건 저장",
                    condName: "",
                  });
                }}
              />
            </div>

            <div
              style={{ marginTop: "1rem" }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onClickSearch(false, 1);
                }
              }}
            >
              <ComboBox
                labelWidth={"2.5rem"}
                comboItemWidth="18.1rem"
                marginRight="0rem"
                labelText="본부"
                data={hqBranchData.hq_list}
                defaultValue={getDefaultValue("combo", baseSearchParam?.hq_info.hq_name) || ""}
                onChangeCallback={(e) => {
                  onSelectHq(e.target.value);
                }}
              />
              <SearchComboBox
                marginTop="0.5rem"
                labelWidth={"2.5rem"}
                comboItemWidth="18.1rem"
                marginRight="0rem"
                labelText="지점"
                data={hqBranchData.branch_list[hqIdx]}
                defaultValue={
                  getDefaultValue("combo", baseSearchParam?.branch_info.branch_name) || ""
                }
                onChangeCallback={(e, v) => {
                  onSelectBranch(v);
                }}
              />
            </div>

            <div>
              {/* 회원 정보 */}
              <div style={{ marginTop: "0.5rem", width: "21.2rem" }}>
                <MemberConditionArea
                  searchParam={baseSearchParam}
                  setSearchParam={setBaseSearchParam}
                  onClickSearch={onClickSearch}
                  resetFlag={resetFlag}
                  openMemberInfo={openMemberInfo}
                  setOpenMemberInfo={setOpenMemberInfo}
                />
              </div>

              {/* 기준별 검색 조건 */}
              <div style={{ marginTop: "0.5rem", width: "21.2rem" }}>
                <SearchDetailArea
                  searchParam={detailSearchParam}
                  setSearchParam={setDetailSearchParam}
                  detailOption={detailOption}
                  setDetailOption={setDetailOption}
                  openSearchDetail={openSearchDetail}
                  setOpenSearchDetail={setOpenSearchDetail}
                  onChangeDetailOption={onChangeDetailOption}
                />
              </div>
            </div>
          </div>
        }
        isLoading={false}
        rootStyle={{
          width: "22.6rem",
          maxHeight: "48rem",
          borderRadius: "10px",
          padding: "0.75rem 0.2rem 0.75rem 0.5rem",
          backgroundColor: "#fff",
          overflowY: "auto",
        }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          marginTop: "0.5rem",
          backgroundColor: "white",
          borderRadius: "10px",
          padding: "0.75rem 1rem",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
          gap: "0.25rem",
        }}
      >
        <NormalBtn
          name="조건 초기화"
          theme="white"
          width="10.5rem"
          onClick={() => {
            setResetFlag(!resetFlag);
            resetSearchParam();
          }}
        />

        <NormalBtn
          name="검색"
          width="10.5rem"
          onClick={() => {
            onClickSearch(false, 1);
          }}
        />
      </div>
    </>
  );
};
export default SearchCard;
